import { ProviderType } from "@/services/cloudchipr.api";
import { getProviderName } from "@/utils/helpers/providers/getProviderName";

export const generateCostTypeProvidersText = (providers: ProviderType[]) => {
  return providers?.reduce((result, item, index) => {
    if (index > 0) {
      result += " and ";
    }
    result += getProviderName(item, { title: true });

    return result;
  }, "");
};
